import type { ViewIds } from '@ardoq/api-types';
import { clearGraphSelection } from '@ardoq/component-selection';
import { featureOperations, Features } from '@ardoq/features';
import { combineLatest, map } from 'rxjs';
import { dispatchAction } from '@ardoq/rxbeach';
import { featureContext$ } from 'streams/featureContext$';
import { activeView$ } from 'streams/views/mainContent/activeView$';
import { hideViewSidePanel } from 'views/mainApp/viewSidePanel/actions';
import { closeSidebarPanel } from 'canvas/sidebarPanel/actions';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { toViewPickerViewIds } from 'views/environmentals/getViewpointModeSupportedViews';
import { viewpointModeViews$ } from 'views/modeViews$';
import { setActiveMainTabLeft } from 'streams/views/mainContent/actions';
import { trackViewStyleChange } from './viewPaneHeader/tracking';

const viewPaneHeader$ = combineLatest([
  activeView$,
  viewpointModeViews$,
  featureContext$,
  i18nLocale$,
]).pipe(
  map(([{ mainViewId }, viewpointModeViews, featureContext, i18nLocale]) => {
    // KFQ12026
    const isCanvasPrototype = featureOperations.hasFeature(
      featureContext,
      Features.CANVAS_PROTOTYPE
    );

    const viewPickerViewIds = toViewPickerViewIds(viewpointModeViews.ids);

    const onCloseClick = () => {
      if (isCanvasPrototype) {
        dispatchAction(closeSidebarPanel());
      } else {
        dispatchAction(hideViewSidePanel());
      }
    };

    const onViewSelected = (renderedViewId: ViewIds) => {
      trackViewStyleChange(mainViewId, renderedViewId);
      dispatchAction(
        setActiveMainTabLeft({
          activeTabId: renderedViewId,
          isViewpointMode: true,
        })
      );
      // KFQ12026
      if (isCanvasPrototype) {
        dispatchAction(clearGraphSelection());
      }
    };

    return {
      mainViewId,
      isCanvasPrototype,
      viewPickerViewIds,
      onCloseClick,
      onViewSelected,
      i18nLocale,
    };
  })
);
export { viewPaneHeader$ };
